import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import Intro from '@app/layout/Intro.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import JobList from '@app/pages/customer/jobs/JobList.tsx';

interface ComponentProps {}

const JobsPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  return (
    <ResponsiveLayout
      title={tr('JobList.title', 'Rozpracované úkoly')}
      oneOfPermission={[PermissionTypesEnum.PERMISSION_JOBS_READ, PermissionTypesEnum.PERMISSION_JOBS_RW]}
    >
      <JobList />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(JobsPage, {
  onRedirecting: () => <Intro />,
});
